import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { SERVICE_DETAIL_BANNERS } from '../service-detail-banners';
import { ServiceOrbitVisualComponent } from '../shared/service-orbit-visual/service-orbit-visual.component';


@Component({
  selector: 'app-call-center',
  standalone: true,
  imports: [CommonModule, RouterLink, ServiceOrbitVisualComponent],
  templateUrl: './call-center.component.html',
  styleUrl: './call-center.component.scss',
  host: {
    '[style.--service-banner-image]': 'serviceBannerImage',
  },
})
export class CallCenterComponent {
  readonly serviceBannerImage = SERVICE_DETAIL_BANNERS.callCenter;
}
